import React from "react";
import ReactDOM from "react-dom";
import {
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush 
} from 'recharts';


const CustomTooltip = (active:any, payload:any, label:any ) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
        <p className="intro">{`${label} : ${payload[0].value}`}</p>
        <p className="desc">Anything you want can be displayed here.</p>
      </div>
    );
  }

  return null;
};


// const data1 = [
//   {
//     name: 'کنترل', count: 4, failedCount: 2
//   },
//   {
//     name: 'کنترل تست', count: 3, failedCount: 1
//   },
//   {
//     name: 'T-Britin', count: 5, failedCount: 2
//   },
//   {
//     name: 'اقدام اصلاحی', count: 2
//   },
  
// ];

// const color = ["#12e4dd","#f49f17"]
// const legendLabel = [
//   {
//     name: 'count', value:"تعداد کل انجام شده"
//   },
//   {
//     name: 'failedCount', value:"هشدار تعداد غیرمجاز"
//   }
  
// ];

type Props = {
    data: any[];
    colors: any[];
    legendLabel:any[];
  }
  type State = {
    chartData: any[];
    colors: any[];
    legendLabel:any[];
    }
class MultiBarChart extends React.Component<Props,State>{

  constructor(props: Props) {
    super(props);
    this.state = {
      chartData: props.data,
      colors:props.colors,
      legendLabel:props.legendLabel
    };
  }

  getBar = () => {
    const keysArr = Object.keys(this.state.chartData[0]).slice(1);
    const barArr:any[]= [];
    keysArr.forEach((item, index)=> {
      barArr.push(<Bar dataKey={item} fill={this.state.colors[index]} />)
    })
    return barArr;
  }

  
 

  handleSort = (item1:any, item2:any) => {
    // console.log(item1, item2);
    return 1;
  }

   renderLegend = (props:any) => {
    const { payload } = props;
    console.log(payload)
    return (
      <div style={{textAlign:'center'}}>
        {
          payload.map((entry:any, index:any) => (
            <span key={`item-${index}`}><div style={{display:'inline-block',width:'12px',height:'12px',backgroundColor:entry.color,marginRight:'15px'}}></div>{entry.value}</span>
          ))
        }
      </div>
    );
  }

  render() {
    return (
      <BarChart
        width={800}
        height={400}
        data={this.state.chartData}
        margin={{
          top: 20, right: 30, left: 20, bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} vertical={false}/>
        <XAxis dataKey={Object.keys(this.state.chartData[0])[0]} />
        <YAxis />
        <Tooltip /> 
        <Legend iconType="circle"  payload={
                this.state.legendLabel.map(
                    (item, index) => ({
                      id: item.name,
                      type: "square",
                      value: `${item.value}`,
                      color: this.state.colors[index % this.state.colors.length]
                    })
                  )
                } content={this.renderLegend}>
        </Legend>
           {this.getBar()}
          <BarChart>
            {this.getBar()}
          </BarChart>
      </BarChart>
    );
  }
}

export default MultiBarChart;

